import React, { useState } from 'react';
import { loginUser } from '../services/api';
import { useNavigate } from 'react-router-dom';

function Login({ onLoginSuccess }) {
  const [employeeID, setEmployeeID] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      const userData = await loginUser(employeeID, password);
      if (userData && userData.userPK) {
        onLoginSuccess(userData.userPK);
      } else {
        setError('Invalid login credentials');
      }
    } catch (error) {
      setError(error.message || 'Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full relative overflow-hidden">
      {/* Fullscreen Background Image */}
      <img 
        src="/loginp2.jpeg" 
        alt="Welcome Background" 
        className="absolute inset-0 w-full h-full object-cover z-0" 
      />
      {/* Optional: Overlay for darkening the image slightly */}
      <div className="absolute inset-0 bg-gradient-to-br from-black/40 to-black/10 z-10" />

      {/* Top-left logo */}
      <div className="absolute top-0 left-0 z-20 pt-0 pl-8 md:pt-0 md:pl-12 lg:pt-2 lg:pl-16">
        <img src="/Hindalco_Logo.svg.png" alt="Hindalco Logo" className="w-20 md:w-24 lg:w-28" />
      </div>
      {/* Uplifted Welcome text */}
      <div className="absolute left-0 z-20 mt-8 md:mt-16 lg:mt-24 ml-8 md:ml-12 lg:ml-16" style={{maxWidth: '50vw', top: '80px'}}>
        <h2 className="text-4xl md:text-5xl  text-orange-400 mb-2 drop-shadow-lg">Hey There!</h2>
        <h1 className="text-7xl md:text-8xl  text-orange-400 drop-shadow-lg leading-none">Welcome</h1>
      </div>

      {/* Login Card flush with right edge, taller and wider, rounded only on left, more shadow */}
      <div className="fixed top-4 bottom-4 right-0 flex items-center z-30 mr-2">
        <div className="h-[99vh] w-[440px] max-w-full bg-white bg-opacity-95 rounded-3xl shadow-3xl flex flex-col justify-center px-6 py-6">
          <div className="w-full flex flex-col flex-1">
            {/* DRIVE 360 Logo */}
            <img 
              src="/DRIVE360.png"
              alt="DRIVE 360 Logo" 
              className="w-72 mx-auto mb-10"
            />
            <h2 className="text-2xl font-bold text-gray-800 mb-5 tracking-wide font-poppins text-left">User Login</h2>
            <form onSubmit={handleLogin} className="space-y-8">
              <input
                id="employeeID"
                type="text"
                value={employeeID}
                onChange={(e) => setEmployeeID(e.target.value)}
                className="w-full px-5 py-4 bg-gray-100 rounded-lg border border-gray-300 focus:ring-2 focus:ring-orange-400 focus:border-transparent outline-none text-lg placeholder-gray-400"
                placeholder="User Name"
                disabled={isLoading}
                autoComplete="username"
              />
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-5 py-4 bg-gray-100 rounded-lg border border-gray-300 focus:ring-2 focus:ring-orange-400 focus:border-transparent outline-none text-lg placeholder-gray-400"
                placeholder="User Password"
                disabled={isLoading}
                autoComplete="current-password"
              />
              {/* Error message only if login fails */}
              {error && (
                <div className="bg-red-50 text-red-600 p-3 rounded-lg text-sm border border-red-200 text-center">
                  {error}
                </div>
              )}
              <div className="flex gap-4 pt-1">
                <button
                  type="submit"
                  disabled={isLoading}
                  className={`flex-1 text-base font-semibold py-2 rounded-lg transition duration-300 flex items-center justify-center ${
                    isLoading
                      ? 'bg-orange-300 text-white cursor-not-allowed'
                      : 'bg-orange-500 hover:bg-orange-600 text-white shadow-md'
                  }`}
                >
                  {isLoading ? 'Logging in...' : 'Login'}
                </button>
                <button
                  type="button"
                  className="flex-1 text-base font-semibold py-2 rounded-lg border-2 border-gray-300 bg-white hover:bg-gray-100 text-gray-800 transition duration-300 shadow-md"
                  tabIndex={-1}
                  onClick={() => navigate('/signup')}
                >
                  Sign Up
                </button>
              </div>
            </form>
          </div>
          {/* Powered by section at the bottom */}
          <div className="w-full mx-auto mt-12 pt-6 border-t border-gray-200 flex items-center justify-between text-base">
            <div className="flex items-center gap-2">
              <span className="text-gray-500">Powered by:</span>
              <img src="/Eframe.png" alt="Eframe Logo" className="h-8" />
            </div>
            <div className="text-right">
              <p className="text-gray-800 font-medium">Eframe Infomedia Pvt Ltd</p>
              <a
                href="https://www.eframe.in/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-orange-500 hover:underline transition-colors"
              >
                www.eframe.in
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
